import React from "react"

import { iArticleContent, iPageContext } from "../../types"
import ContentBullets from "./ContentBullets"
import ContentHeading from "./ContentHeading"
import ContentParagraph from "./ContentParagraph"
import ContentTitle from "./ContentTitle"

const ContentController: React.FC<{
  pageContext: iPageContext
  data: iArticleContent[]
  defaultLanguage?: string
  bookmarked: boolean | null
  onClickShare: () => void
  onClickBookmark: () => void
  onClickDiscussion: () => void
}> = ({
  data,
  defaultLanguage,
  pageContext,
  bookmarked,
  onClickShare,
  onClickBookmark,
  onClickDiscussion,
}) => {
  if (!data) return <p>Content content available</p>
  return (
    <>
      {data.map((item: any, index: any) => {
        return (
          <React.Fragment key={`${index}-fragment`}>
            <ContentTitle
              onClickDiscussion={onClickDiscussion}
              bookmarked={bookmarked}
              key={`${index}-t`}
              defaultLanguage={defaultLanguage}
              content={item.title}
              last_updated_at={pageContext.data.last_updated_at}
              read_time={pageContext.data.read_time}
              onClickShare={onClickShare}
              onClickBookmark={onClickBookmark}
            />
            <ContentHeading
              key={`${index}-h`}
              defaultLanguage={defaultLanguage}
              content={item.heading}
            />
            <ContentParagraph
              key={`${index}-p`}
              defaultLanguage={defaultLanguage}
              content={item.paragraph}
            />
            <ContentBullets
              content={item.bullets}
              defaultLanguage={defaultLanguage}
              key={`${index}-bullet`}
            />
          </React.Fragment>
        )
      })}
    </>
  )
}

export default ContentController
